import {styled} from '@mui/material'
import {Colors, Images, Texts} from 'appearance'
import Button from 'components/Control/Button'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {useFormContext} from 'react-hook-form'
import {serverPhoneFormat} from 'services/utils/apiUtils'
import {useI18n, useSendSmsForSignupMutation} from 'store/Store'
import WizardComponentWrapper from '../WizardComponentWrapper'
import {useDeviceDetect, useYupValidation} from 'services/hooks'
import {registerSmsVerificationSchema} from 'services/utils/validationsSchemas'
import useTimerString from 'logic/Auth/useTimerString'
import analyticsService from 'services/analytic'

const SMSVerification = ({setValidationError}) => {
    const {i18n} = useI18n()
    const {isMobile} = useDeviceDetect()

    const {timeStr, resetTime} = useTimerString()

    const [doSendSmsForSignup] = useSendSmsForSignupMutation()

    const formContext = useFormContext()
    const {
        watch,
        control: formControl,
        formState: {errors: formErrors},
        getValues,
    } = formContext

    const phone = watch('username')
    const sms = watch('sms')

    useYupValidation(
        registerSmsVerificationSchema,
        getValues,
        [sms],
        setValidationError
    )

    const handleSendSms = () => {
        resetTime()
        doSendSmsForSignup({
            phone: serverPhoneFormat(phone),
        })
        analyticsService.forgotPasswordPressed(
            'send_again_on_verify_phone_number'
        )
    }

    return (
        <WizardComponentWrapper sideImage={Images.REGISTER_STEP_2}>
            <Text>
                {i18n.t('register.smsVerificationText', {
                    phone,
                })}
            </Text>

            <InputWrapper isMobile={isMobile}>
                <FormTextInput
                    name="sms"
                    label={i18n.t('register.verificationCode')}
                    control={formControl}
                    fullWidth
                    type="number"
                    initialValue=""
                    errors={formErrors}
                    height="48px"
                    style={{color: '#95969A'}}
                    InputProps={{style: {background: '#FAFAFA'}}}
                />
                <TimerText>
                    {i18n.t('login.codeWillArrive', {time: timeStr})}
                </TimerText>
                <Button
                    // color="secondary"
                    style={{marginTop: 24, color: Colors.LINK_TEXT}}
                    onClick={handleSendSms}>
                    {i18n.t('register.resend')}
                </Button>
            </InputWrapper>
        </WizardComponentWrapper>
    )
}

export default SMSVerification

const Text = styled(Texts.BoldText)`
    font-size: 24px;
`

const InputWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-inline: auto;
    width: ${({isMobile}) => (isMobile ? 100 : 40)}%;
    margin-top: 90px;
`

const TimerText = styled(Texts.RegularText)`
    margin-top: 14px;
    text-align: center;
`
